import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";
import { TypeRampV2 } from "../../../typography";
var PLACEHOLDER_LEFT_WITH_CONTENTBEFORE = "40px";
var PLACEHOLDER_LEFT_DEFAULT = "12px";
export var SelectPlaceholderStyled = styled(TypeRampV2)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n\n    position: absolute;\n    top: 11px;\n    left: ", ";\n\n    user-select: none;\n    right: 30px;\n    text-align: left;\n    pointer-events: none;\n"])), function (_ref) {
  var themeMode = _ref.themeMode;
  return formInputTheme.placeholderColor.hover(themeMode);
}, function (_ref2) {
  var hasContentBefore = _ref2.hasContentBefore;
  return hasContentBefore ? PLACEHOLDER_LEFT_WITH_CONTENTBEFORE : PLACEHOLDER_LEFT_DEFAULT;
});
//# sourceMappingURL=SelectPlaceholderStyled.js.map